import { IconProp } from '@fortawesome/fontawesome-svg-core';

export enum OptionType {
  BUDGET = 'budget',
  ALLERGY = 'allergy',
  CONTACT_US_TOPIC = 'contact_us_topic',
  CUISINE = 'cuisine',
  DISH_TYPE = 'dish_type',
  FAMILY_FRIENDLY = 'family_friendly',
  MAIN_INGREDIENT = 'main_ingredient',
  PREPARATION_TIME = 'preparation_time',
  SERVING_SIZE = 'serving_size',
  SKILL_LEVEL = 'skill_level',
  SPECIAL_DIET = 'special_diet',
  TEXTURE = 'texture',
  PLAN_MANAGER = 'plan_manager',
  MEAL_TYPE = 'meal_type',
}

export interface OptionModel {
  id: string;

  /** Option Type */
  type: OptionType;

  /** Display label of the Option */
  label: string;

  /** Special Reference Code of the Option */
  code: string;

  /** Fontawesome Icon Reference */
  icon?: IconProp;

  /** Whether to exclude this option */
  excl?: boolean;
}
/**
 * A map of options grouped by option types.
 * E.g.
 * {
 *  "mealType": [...],
 *  "specialDiets": [...]
 *  ...
 * }
 */
export interface Options {
  [key: string]: OptionModel[];
}
